/* @ngInject */
const destructionExcel = (
  excelUtils,
  excelStyles,
  types
) => {
  const self = {}

  const firstRow = 10

  const headerCell = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    borderStyle: 'thick',
    borderColor: '000000',
    border: {
      top: true,
      bottom: true,
      left: true,
      right: true,
    },
    bold: true,
    underline: true,
    fill: {
      type: 'solid',
      color: 'D9D9D9',
    },
  }

  const subHeaderCell = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    borderStyle: 'medium',
    borderColor: '000000',
    border: {
      top: true,
      bottom: true,
      left: true,
      right: true,
    },
    bold: true,
  }

  const bodyCell = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    borderStyle: 'thick',
    borderColor: '000000',
    border: {
      top: true,
      bottom: true,
      left: true,
      right: true,
    },
  }

  const wrapCell = {
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
    wrapText: true,
    borderStyle: 'medium',
    borderColor: '000000',
    border: {
      top: true,
      bottom: true,
      left: true,
      right: true,
    },
  }

  self.generate = (sale, wagon) => {
    return excelUtils.getWorkbook('destruction')
      .then((workbook) => {
        const sheet = workbook.sheet(0)
        self.setHeader(sheet, sale, wagon)
        self.setBody(sheet, wagon.axletrees, wagon.pieces)
        return workbook.outputAsync({
          type: '',
        })
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.download = (sale, wagon) => {
    return self.generate(sale, wagon)
      .then((blob) => {
        excelUtils.downloadWorkbook(blob, 'Certificat de destruction')
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.setHeader = (sheet, sale, wagon) => {
    self.getHeaderCells(sale, wagon).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })
  }

  self.getHeaderCells = (_sale, _wagon) => {
    return [{
      name: `E2`,
      value: _wagon.id,
      type: types.wagonId,
      style: { fontSize: 20, },
    }, {
      name: `G5`,
      value: _sale.owner,
      style: { fontSize: 12, },
    }, {
      name: `B7`,
      value: _sale.number,
      style: { fontSize: 14, },
    }, {
      name: `H7`,
      value: _wagon.tare,
      style: { fontSize: 14, },
    },]
  }

  self.setBody = (sheet, axletrees, pieces) => {
    let rowIndex = 19

    axletrees = axletrees.sort((a, b) => {
      // if (!a.pos || !b.pos) return false
      const aPos = +a.position.split(' - ')[0]
      const bPos = +b.position.split(' - ')[0]
      return aPos > bPos
    })

    self.getAxletreesHeaderCells(rowIndex).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })

    rowIndex += 2

    for (const axletree of axletrees) {
      self.getAxletreesCells(axletree, rowIndex).forEach(cellInfo => {
        excelUtils.setCell(sheet, cellInfo)
      })
      rowIndex++
    }

    const axletreesRestitues = axletrees.filter(a => a.decision === 'Restitué')

    if (axletreesRestitues.length) {
      rowIndex += 1

      self.getAxletreesRestituesHeaderCells(rowIndex).forEach(cellInfo => {
        excelUtils.setCell(sheet, cellInfo)
      })

      rowIndex += 2

      for (const axletree of axletreesRestitues) {
        self.getAxletreesRestituesCells(axletree, rowIndex).forEach(cellInfo => {
          excelUtils.setCell(sheet, cellInfo)
        })
        rowIndex++
      }
    }

    if (pieces.length) {
      rowIndex += 1

      self.getPiecesHeaderCells(rowIndex).forEach(cellInfo => {
        excelUtils.setCell(sheet, cellInfo)
      })

      rowIndex += 1

      for (const piece of pieces) {
        self.getPiecesCells(piece, rowIndex).forEach(cellInfo => {
          excelUtils.setCell(sheet, cellInfo)
        })
        rowIndex++
      }
    }

    rowIndex += 1

    self.footerCells(rowIndex).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })
  }

  self.getAxletreesHeaderCells = (_index) => {
    return [{
      name: `A${_index}`,
      value: `RELEVÉS ESSIEUX`,
      type: types.text(),
      mergeRange: `A${_index}:I${_index}`,
      style: headerCell,
    }, {
      name: `A${_index + 1}`,
      value: `Position`,
      type: types.text(),
      style: subHeaderCell,
    }, {
      name: `B${_index + 1}`,
      value: `Numéro`,
      type: types.text(),
      style: subHeaderCell,
      mergeRange: `B${_index + 1}:C${_index + 1}`,
    }, {
      name: `D${_index + 1}`,
      value: `Type`,
      type: types.text(),
      style: subHeaderCell,
      mergeRange: `D${_index + 1}:F${_index + 1}`,
    }, {
      name: `G${_index + 1}`,
      value: `Mesure relevée`,
      type: types.text(),
      style: subHeaderCell,
    }, {
      name: `H${_index + 1}`,
      value: `Décision`,
      type: types.text(),
      style: subHeaderCell,
      mergeRange: `H${_index + 1}:I${_index + 1}`,
    },]
  }

  self.getAxletreesCells = (_axletree, _index) => {
    return [{
      name: `A${_index}`,
      value: _axletree.position,
      type: types.text(),
      style: bodyCell,
    }, {
      name: `B${_index}`,
      value: _axletree.number,
      type: types.text(),
      mergeRange: `B${_index}:C${_index}`,
      style: bodyCell,
    }, {
      name: `D${_index}`,
      value: _axletree.type,
      type: types.text(),
      mergeRange: `D${_index}:F${_index}`,
      style: bodyCell,
    }, {
      name: `G${_index}`,
      value: _axletree.material,
      type: types.text(),
      style: bodyCell,
    }, {
      name: `H${_index}`,
      value: _axletree.decision,
      type: types.text(),
      mergeRange: `H${_index}:I${_index}`,
      style: bodyCell,
    },]
  }

  self.getAxletreesRestituesHeaderCells = (_index) => {
    return [{
      name: `A${_index}`,
      value: `TRAITEMENT ESSIEUX RESTITUÉS`,
      type: types.text(),
      mergeRange: `A${_index}:I${_index}`,
      style: headerCell,
    }, {
      name: `A${_index + 1}`,
      value: `Position`,
      type: types.text(),
      style: subHeaderCell,
    }, {
      name: `B${_index + 1}`,
      value: `Date d'expédition`,
      type: types.text(),
      style: subHeaderCell,
      mergeRange: `B${_index + 1}:C${_index + 1}`,
    }, {
      name: `D${_index + 1}`,
      value: `Lieu d'expédition`,
      type: types.text(),
      style: subHeaderCell,
      mergeRange: `D${_index + 1}:I${_index + 1}`,
    },]
  }

  self.getAxletreesRestituesCells = (_axletree, _index) => {
    return [{
      name: `A${_index}`,
      value: _axletree.position,
      type: types.text(),
      style: bodyCell,
    }, {
      name: `B${_index}`,
      value: _axletree.expeditionDate,
      type: types.date,
      mergeRange: `B${_index}:C${_index}`,
      style: bodyCell,
    }, {
      name: `D${_index}`,
      value: _axletree.expeditionPlace,
      type: types.text(),
      mergeRange: `D${_index}:I${_index}`,
      style: bodyCell,
    },]
  }

  self.getPiecesHeaderCells = (_index) => {
    return [{
      name: `A${_index}`,
      value: `Pièces à récupérer :`,
      type: types.text(),
      mergeRange: `A${_index}:B${_index}`,
      style: headerCell,
    }, {
      name: `C${_index}`,
      value: `Nombres`,
      type: types.text(),
      mergeRange: `C${_index}:F${_index}`,
      style: headerCell,
    }, {
      name: `G${_index}`,
      value: `Date`,
      type: types.text(),
      style: headerCell,
    }, {
      name: `H${_index}`,
      value: `Lieu`,
      type: types.text(),
      mergeRange: `H${_index}:I${_index}`,
      style: headerCell,
    },]
  }

  self.getPiecesCells = (_piece, _index) => {
    return [{
      name: `A${_index}`,
      value: _piece.name,
      type: types.text(),
      style: bodyCell,
      mergeRange: `A${_index}:B${_index}`,
    }, {
      name: `C${_index}`,
      value: _piece.quantity,
      type: types.integer,
      style: bodyCell,
      mergeRange: `C${_index}:F${_index}`,
    }, {
      name: `G${_index}`,
      value: _piece.sendingDate,
      type: types.date,
      style: bodyCell,
    }, {
      name: `H${_index}`,
      value: _piece.sendingPlace,
      type: types.text(),
      style: bodyCell,
      mergeRange: `H${_index}:I${_index}`,
    },]
  }

  self.footerCells = (_index) => {
    return [{
      name: `A${_index}`,
      value: `Certificat établi le`,
      type: types.text(),
      style: headerCell,
      mergeRange: `A${_index}:B${_index}`,
    }, {
      name: `C${_index}`,
      value: ``,
      type: types.text(),
      style: headerCell,
      mergeRange: `C${_index}:D${_index}`,
    }, {
      name: `F${_index}`,
      value: `Ferraillé à`,
      type: types.text(),
      style: headerCell,
      mergeRange: `F${_index}:G${_index}`,
    }, {
      name: `H${_index}`,
      value: ``,
      type: types.text(),
      style: headerCell,
      mergeRange: `H${_index}:I${_index}`,
    }, {
      name: `A${_index + 1}`,
      value: `Je soussigné Jérôme GORGOL, représentant de la société SGM Recyclage, atteste par la présente la destruction de ce wagon.`,
      type: types.text(),
      style: wrapCell,
      mergeRange: `A${_index + 1}:D${_index + 4}`,
    }, {
      name: `F${_index + 1}`,
      value: `Cachet et signature`,
      mergeRange: `F${_index + 1}:I${_index + 4}`,
      type: types.text(),
      style: {
        horizontalAlignment: 'left',
        verticalAlignment: 'top',
        borderStyle: 'medium',
        borderColor: '000000',
        border: {
          top: true,
          bottom: true,
          left: true,
          right: true,
        },
      },
    },]
  }


  return self
}
export default destructionExcel



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/scrapping/destructionExcel.service.js